export class Overlay {

	static selector = '.js-filter-overlay';

	constructor(node) {
		this.node = node;
	}

	activate() {
		let self = this;
		self.fadeIn();
	}

	deactivate() {
		let self = this;
		self.fadeOut();
	}

	fadeIn() {
		let node = this.node;

		node.style.opacity = '0';
		node.style.display = 'block';

		(function fade() {
			let val = parseFloat(node.style.opacity) + 0.1;
			if (val <= 1) {
				node.style.opacity = val + '';
				requestAnimationFrame(fade);
			}
		})();
	}

	fadeOut() {
		let node = this.node;

		node.style.opacity = '1';
		node.style.display = 'block';

		(function fade() {
			let val = parseFloat(node.style.opacity) - 0.1;
			if (val < 0) {
				node.style.display = 'none';
			} else {
				node.style.opacity = val + '';
				requestAnimationFrame(fade);
			}
		})();
	}
}
